// src/components/HeroSection.js (or wherever HeroSection is located)
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import HeroBanner from '../Components/LandingPage/HeroBanner';
import ServicesCards from '../Components/LandingPage/ServicesCards';
import ScrollMarquee from '../Components/LandingPage/ScrollMarquee';
import StatsSection from '../Components/LandingPage/StatsSection';
import AboutIntro from '../Components/LandingPage/AboutIntro';
import FeaturesSection from '../Pages/FeaturesSection';
import TechnologiesSection from '../Components/LandingPage/TechnologiesSection';
import CTABanner from '../Components/LandingPage/CTABanner';
import Partners from '../Components/Partners';
import TeamSection from '../Components/TeamSection';
import FinalCTA from '../Components/LandingPage/FinalCTA';
import VisionMission from '../Components/LandingPage/VisionMission';

const HeroSection = () => {
  useEffect(() => {
    AOS.init({ 
      duration: 1000, 
      offset: 120, 
      once: true 
    });
  }, []);

  return (
    <div className="home-container">
      <HeroBanner />
      <ServicesCards />
      <ScrollMarquee />
      <StatsSection />
      <AboutIntro />
      <FeaturesSection />
      <TechnologiesSection />
      <VisionMission />
      <TeamSection /> 
      <CTABanner />
      <Partners />
      <FinalCTA />
    </div>
  );
};

export default HeroSection;